import React from 'react';

export const ProcessError = ({ color }: { color?: string }): JSX.Element => {
    const className = 'icon icon--process-error';
    color = color || '#0076CC';

    return (
        <svg 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        {...{ className }}
        >
            <g clipPath="url(#clip0_9818_3855)">
                <path d="M3 4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H8C8.26522 3 8.51957 3.10536 8.70711 3.29289C8.89464 3.48043 9 3.73478 9 4V8C9 8.26522 8.89464 8.51957 8.70711 8.70711C8.51957 8.89464 8.26522 9 8 9H4C3.73478 9 3.48043 8.89464 3.29289 8.70711C3.10536 8.51957 3 8.26522 3 8V4Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M17.8997 16.0558V18" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M17.1634 13.623L13.5155 19.7138C13.4403 19.844 13.4005 19.9917 13.4 20.1421C13.3996 20.2924 13.4385 20.4403 13.513 20.571C13.5875 20.7016 13.6948 20.8105 13.8244 20.8868C13.954 20.9631 14.1013 21.0041 14.2517 21.0058H21.5486C21.6989 21.0041 21.8461 20.9631 21.9757 20.8868C22.1052 20.8105 22.2125 20.7017 22.287 20.5711C22.3614 20.4405 22.4004 20.2927 22.4 20.1424C22.3996 19.9921 22.3599 19.8445 22.2848 19.7142L18.6369 13.6226C18.5601 13.4959 18.452 13.3911 18.3229 13.3184C18.1939 13.2457 18.0483 13.2075 17.9002 13.2075C17.752 13.2075 17.6064 13.2457 17.4774 13.3184C17.3483 13.3911 17.2402 13.4959 17.1634 13.6226V13.623Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M17.8997 19.4329H17.9038" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20.9993 11V8C20.9993 7.46957 20.7886 6.96086 20.4135 6.58579C20.0384 6.21071 19.5297 6 18.9993 6H12.9993M12.9993 6L15.9993 9M12.9993 6L15.9993 3" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3 12.9993V15.9993C3 16.5297 3.21071 17.0384 3.58579 17.4135C3.96086 17.7886 4.46957 17.9993 5 17.9993H11M11 17.9993L8 14.9993M11 17.9993L8 20.9993" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_9818_3855">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ProcessError;

